export const APP_CONFIG = {
appName: 'Unitek Learning Benefits',
frontend: 'https://uniteklearningbenefits.com',
apiHash: 'https://uniteklearningbenefits.com/api/1.0',
api: '/api/2.0',
trustModel: false,
authType: 'public',
authHeaders: {
xServiceProvider: 'unitek-prod-frontend',
'tenant-id': 'd9b72107-629d-4f2f-a3e4-85e80b8544ba',
'consumer-id': '66691c37-2c17-4efb-af37-902351ace82a',
},
provider: 'unitek-prod-frontend',
colors: {
primary: '#074975',
secondary: '#939597',
},
    imagery: {
        logo: 'https://storage.googleapis.com/bedrocc/unitek-logo.png',
        logoInverted: 'https://storage.googleapis.com/bedrocc/unitek-logo.png',
        logoTransparent: 'https://storage.googleapis.com/bedrocc/unitek-logo.png',
    },
multilingual: true,
demoMode: false,
contactEnabled: true,
chatEnabled: false,
isDarkModeEnabled: false,
gtm: 'GTM-5S2QTSRH',
copyright: '<small>&copy; ' + new Date().getFullYear() +
' Gallagher | All Rights Reserved. Powered by Core.' + '</small>',
navigation: {
navType: 'top',
collapsibleSidenav: false,
headerStyle: 'solid',
navigationOrder: 'displayOrder',
categoryNav: true,
},
cookiePolicy: 'a9f88690',
};
